namespace GeniuzPOS.ReportMasterData {
    export class Report_1201_DtColumns {
        static columnsKey = 'ReportMasterData.Report_1201_Dt';
    }
}
